<template>
  <va-card :title="$t('menu.load_palletizing')">
    <div class="row">
      <div class="flex xs12 sm2">
        <va-date-picker
          :label="$t('tables.date')"
          v-model="delivery_date"
        />
      </div>

      <div class="flex" style="margin-left: -20px">
        <va-button
          small
          color="secondary"
          icon="fa fa-eraser"
          class="ma-2"
          @click="clear(delivery_date)"
        >
          {{ $t('menu.clear') }}
        </va-button>
      </div>

      <div class="flex xs3">
        <va-select
          v-model="loadType"
          :options='loadTypes'
          label="Tipo de Carga"
          textBy="name"
          keyBy="id"
          clearable="false"
          placeholder="Selecione o tipo de carga"
        />
      </div>

      <div class="flex xs2">
        <va-input
          v-model="searchName"
          :label="$t('menu.search')"
          removable
        >
        </va-input>
      </div>

      <div class="flex xs12 md2">
        <va-button
          small
          color="secondary"
          icon="fa fa-search"
          class="ma-2"
          @click="readItems(page, searchName)"
        >
          {{ $t('menu.search') }}
        </va-button>
      </div>

      <div class="flex xs2">
        <va-select
          v-model="perPage"
          :value="perPage"
          :label="$t('tables.perPage')"
          :options="perPageOptions"
        />
      </div>

      <div class="flex">
        <va-toggle
          v-if="this.status.id !== undefined"
          small
          :label="$t('menu.multiplePalletization') "
          v-model="selectable"
          class="ma-2"
          color="secondary"
          @input="readItems()"
        />
      </div>
      <div class="flex">
        <va-button
          v-if="(selectable) && (selectedRows.length > 0) && (ability.can('palletize', 'Loads')) && (status.id == 12)"
          small
          inline
          color="secondary"
          icon="fa fa-check"
          class="ma-2"
          @click="palletizeSelectedLoads()"
        >
          {{ $t('menu.palletizeSelectedLoads') }}
        </va-button>
      </div>

      <div class="flex">
        <va-button
          small
          inline
          color="secondary"
          icon="fa fa-download"
          class="ma-2"
          @click="showConfirmExportPalletizedAllProduct = true, deliveryDateLoadPalletizing = delivery_date, localityLoadPalletizing = this.currentLocality.id">
          {{ $t('menu.export_all_palletized_products') }}
        </va-button>
      </div>

      <div class="flex">
        <va-button
          small
          inline
          color="secondary"
          icon="fa fa-check"
          class="ma-2"
          @click="showConfirmPalletizeAllLoads = true, deliveryDateLoadPalletizing = delivery_date">
          {{ $t('menu.palletizeAllLoads') }}
        </va-button>
      </div>

    </div>

    <va-modal
      v-model="showModal"
      size="large"
      :title=" $t('modal.largeTitle') "
      :message=" $t('modal.message') "
      :cancelText=" $t('modal.cancel') "
    />

    <div v-show="loading" class="text--center pb-4">
      <div class="flex-center spinner-box">
        <slot name="loading">
          <spring-spinner
            slot="loading"
            :animation-duration="currentDuration"
            :is="spload.name"
            :color="spinnersColor"
            :size="config.size"
          />
        </slot>
      </div>
    </div>

    <va-data-table
      v-if="renderComponent"
      :fields="fields"
      :data="data"
      :per-page="parseInt(perPage)"
      :total-pages="parseInt(totalPages)"
      v-show="!loading"
      no-pagination
      api-mode
      @page-selected="readItems"
    >

    <template slot="select" slot-scope="props">
        <va-checkbox
          :value="props.rowData.checked"
          v-model="props.rowData.checked"
          @input="checkRow(props.rowData.id, props.rowData.checked)"
          v-if="selectable" />
    </template>

    <template slot="actions" slot-scope="props">
      <template v-if="ability.can('palletize', 'Loads')">
        <va-button
          small
          inline
          color="secondary"
          icon="fa fa-check"
          class="ma-0"
          @click="palletizeLoad(props.rowData.id)"
          v-if="!selectable && props.rowData.status_id === 12">
          {{ $t('menu.palletize_load') }}
        </va-button>
      </template>

      <va-button
          small
          inline
          color="secondary"
          icon="fa fa-download"
          class="ma-0"
          v-if="props.rowData.status_id > 13"
          @click="showConfirmExportPalletizedProduct = true, codLoadPalletizing = props.rowData.id">
          {{ $t('menu.export_palletized_products') }}

        </va-button>

      <va-button
        small
        inline
        color="#ff842b"
        icon="fa fa-table"
        class="ma-1"
        v-if="!selectable && props.rowData.status_id === 13"
        :to="{ name: 'sorted_products', params: { loadID: props.rowData.id, loadCode: props.rowData.code, delivery_date: delivery_date, assemblyLine: 11, current_page: current_page, searchName: searchName, perPage: perPage } }"
      >
        {{ $t('menu.palletized_products') }}
      </va-button>

      <va-button
        small
        inline
        color="#ff842b"
        icon="fa fa-table"
        class="ma-1"
        v-if="!selectable && props.rowData.status_id > 13"
        :to="{ name: 'palletized_products_by_load', params: { loadID: props.rowData.id, loadCode: props.rowData.code, delivery_date: delivery_date, assemblyLine: 11, current_page: current_page, searchName: searchName, perPage: perPage } }"
      >
        {{ $t('menu.palletized_products') }}
      </va-button>

      <va-button
        small
        inline
        color="greenLight"
        icon="fa fa-list-alt"
        class="ma-1"
        v-if="!selectable"
        :to="{ name: 'data-table-load-products', params: { loadID: props.rowData.id, loadCode: props.rowData.code, delivery_date: delivery_date, assemblyLine: 11, current_page: current_page, searchName: searchName, perPage: perPage } }"
      >
        {{ $t('menu.products') }}
      </va-button>

      <va-button
        small
        inline
        color="secondary"
        icon="fa fa-table"
        class="ma-1"
        v-if="!selectable && props.rowData.status_id === 13"
        :to="{ name: 'vehicle_bays_draggable', params: { loadID: props.rowData.id, vehicle: props.rowData.vehicle, delivery_date: delivery_date, current_page: current_page, searchName: searchName, perPage: perPage } }"
      >
        {{ $t('menu.edit') }}
      </va-button>
      <va-button
        small
        inline
        color="success"
        icon="fa fa-table"
        class="ma-0"
        v-if="!selectable && props.rowData.status_id > 13"
        :to="{ name: 'vehicle_bays_draggable', params: { loadID: props.rowData.id, vehicle: props.rowData.vehicle, delivery_date: delivery_date, current_page: current_page, searchName: searchName, perPage: perPage } }"
      >
        {{ $t('menu.show') }}
      </va-button>
      <va-button
        small
        inline
        color="dark"
        icon="fa fa-list-alt"
        class="ma-0"
        v-if="!selectable && props.rowData.status_id > 13"
        :to="{ name: 'lists-load-table', params: { loadID: props.rowData.id, loadCode: props.rowData.code, assemblyLine: 10, delivery_date: delivery_date, current_page: current_page, searchName: searchName, perPage: perPage } }"
      >
        {{ $t('menu.lists') }}
      </va-button>
      <!-- <va-button
        small
        inline
        color="greenLight"
        icon="fa fa-list-alt"
        class="ma-1"
        :to="{ name: 'data-table-load-products', params: { loadID: props.rowData.id, loadCode: props.rowData.code, backAction: 9, delivery_date: delivery_date, current_page: current_page, search: search, perPage: perPage } }"
      >
        {{ $t('menu.products') }}
      </va-button> -->
      <va-button
        small
        inline
        color="danger"
        icon="fa fa-times"
        class="ma-0"
        @click="showConfirmResetLoadPalletizing = true, codLoadPalletizing = props.rowData.id"
        v-if="!selectable && props.rowData.status_id === 13"
      >
        {{ $t('menu.reset_palletization') }}
      </va-button>

    </template>
    </va-data-table>

      <Pagination
        :currentPage="current_page"
        :totalPages="totalPages"
        :onChange="onPageChange"
        v-show="!loading"
      />

    <va-modal
      v-model="showConfirmResetLoadPalletizing"
      size="small"
      :title="$t('modal.confirm')"
      :message="$t('modal.messageConfirmResetLoadPalletizing')"
      :okText="$t('modal.confirm')"
      :cancelText="$t('modal.cancel')"
      @ok="resetPalletization(codLoadPalletizing)"
    />

    <va-modal
      v-model="showConfirmResetLoadPalletizing"
      size="small"
      :title="$t('modal.confirm')"
      :message="$t('modal.messageConfirmResetLoadPalletizing')"
      hideDefaultActions
      :color="this.$themes.secondary">

      <va-button
        color="danger"
        class="ma-2"
        @click="showConfirmResetLoadPalletizing = false, codLoadPalletizing = props.rowData.id">
        {{$t('modal.cancel')}}
      </va-button>

      <va-button
        color="green"
        class="ma-2"
        @click="resetPalletization(codLoadPalletizing), showConfirmResetLoadPalletizing = false">
        {{$t('modal.confirm')}}
      </va-button>
    </va-modal>

    <va-modal
        v-model="showConfirmExportPalletizedProduct"
        size="small"
        :title="$t('modal.confirm')"
        :message="$t('modal.messageConfirmExportSortedProduct')"
        hideDefaultActions
        :color="this.$themes.secondary"
      >
      <va-button
        color="danger"
        class="ma-2"
        @click="showConfirmExportPalletizedProduct = false">
        {{$t('modal.cancel')}}
      </va-button>

      <va-button
        color="green"
        class="ma-2"
        @click="PalletizedProducts(codLoadPalletizing), showConfirmExportPalletizedProduct = false">
        {{$t('modal.confirm')}}
      </va-button>
    </va-modal>

    <va-modal
        v-model="showConfirmExportPalletizedAllProduct"
        size="small"
        :title="$t('modal.confirm')"
        :message="$t('modal.messageConfirmExportSortedProduct')"
        hideDefaultActions
        :color="this.$themes.secondary"
      >
      <va-button
        color="danger"
        class="ma-2"
        @click="showConfirmExportPalletizedAllProduct = false">
        {{$t('modal.cancel')}}
      </va-button>

      <va-button
        color="green"
        class="ma-2"
        @click="PalletizedAllProducts(deliveryDateLoadPalletizing, localityLoadPalletizing), showConfirmExportPalletizedAllProduct = false">
        {{$t('modal.confirm')}}
      </va-button>
    </va-modal>

    <va-modal
        v-model="showConfirmPalletizeAllLoads"
        size="small"
        :title="$t('modal.confirm')"
        :message="$t('modal.messageConfirmPalletizeAllLoads')"
        hideDefaultActions
        :color="this.$themes.secondary"
      >
      <va-button
        color="danger"
        class="ma-2"
        @click="showConfirmPalletizeAllLoads = false">
        {{$t('modal.cancel')}}
      </va-button>

      <va-button
        color="green"
        class="ma-2"
        @click="PalletizeAllLoads(deliveryDateLoadPalletizing), showConfirmPalletizeAllLoads = false">
        {{$t('modal.confirm')}}
      </va-button>
    </va-modal>
  </va-card>
</template>

<script>

import LoadPalletizingAPI from '@/services/LoadPalletizingAPI'
import LoadAPI from '@/services/LoadAPI'
import moment from 'moment'
import * as spinners from 'epic-spinners'
import { mapState } from 'vuex'
import { Ability } from '@casl/ability'
import { showError } from '@/global'
import LoadTypeAPI from '@/services/LoadTypeAPI'
import Pagination from '../../shared/Pagination'
export const ability = new Ability()

export default {
  name: 'modals',
  components: {
    ...spinners,
    Pagination,
  },
  data () {
    return {
      ability: [],
      data: [],
      loading: false,
      datepicker: {
        today: '',
      },
      showModal: false,
      showConfirmResetLoadPalletizing: false,
      showConfirmExportPalletizedAllProduct: false,
      showConfirmExportPalletizedProduct: false,
      showConfirmPalletizeAllLoads: false,
      config: {
        size: 80,
        group: 4,
        duration: 1500,
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      perPage: '10',
      totalPages: 0,
      perPageOptions: ['10', '20', '30', '50'],
      searchName: '',
      current_page: '',
      renderComponent: true,
      delivery_date: '',
      last_refresh: new Date(),
      loadType: {
        id: '',
        name: '',
      },
      loadTypes: [],
      selectable: false,
      name: '__slot:select',
      selectedRows: [],
      status: {
        id: '',
        name: '',
      },
      statuses: [],
      filepath: [],
    }
  },

  channels: {
    NeedRefreshLoads: {
      received (data) {
        const last_received_refresh = (new Date() - this.last_refresh) / 1000

        if (last_received_refresh >= 30) {
          this.last_refresh = new Date()
          this.readItems()
        }
      }
    }
  },

  beforeMount () {
    this.ability = ability.update(this.rules)
    if (this.$route.params.delivery_date !== undefined) {
      this.delivery_date = `${this.$route.params.delivery_date}`
    } else {
      this.readDeliveryDate(this.currentLocality.id)
    }
  },

  mounted () {
    this.$cable.subscribe({ channel: 'NeedRefreshLoads', company: this.currentUser.company })
    this.searchName = (this.$route.params.searchName !== undefined) ? `${this.$route.params.searchName}` : ''
    this.getDefaultLoadType()
  },
  computed: {
    ...mapState(['rules', 'currentLocality', 'currentUser']),

    fields () {
      return [{
        name: 'id',
        title: this.$t('tables.loads.id'),
      },
      {
        name: 'locality',
        title: this.$t('tables.loads.locality_name'),
      },
      {
        name: 'delivery_date',
        title: this.$t('tables.loads.delivery_date'),
      },
      {
        name: 'trip_number',
        title: this.$t('tables.loads.trip_number'),
      },
      {
        name: 'code',
        title: this.$t('tables.loads.code'),
      },
      {
        name: 'vehicle',
        title: this.$t('tables.loads.vehicle'),
      },
      {
        name: 'vehicle_license_plate',
        title: this.$t('tables.loads.vehicle_license_plate'),
      },
      {
        name: 'vehicle_type_name',
        title: this.$t('tables.loads.vehicleType'),
      },
      {
        name: 'weight',
        title: this.$t('tables.loads.weight'),
      },
      {
        name: 'quantity_orders',
        title: this.$t('tables.loads.quantity_orders'),
      },
      {
        name: 'quantity_boxes',
        title: this.$t('tables.loads.quantity_boxes'),
      },
      {
        name: 'cubage',
        title: this.$t('tables.loads.cubage'),
      },
      {
        name: 'vehicle_percentage',
        title: this.$t('tables.loads.vehiclePercentage'),
      },
      {
        name: 'status',
        title: this.$t('tables.loads.status'),
      },
      {
        name: 'sorting_complexity',
        title: this.$t('tables.loads.sortingComplexity'),
      },
      {
        name: '__slot:actions',
        dataClass: 'text-right',
      }]
    },
    spload () {
      // return spinners.SpinnerName
      return spinners.ScalingSquaresSpinner
    }
  },
  watch: {
    perPage: function (newVal) {
      this.perPage = newVal
      this.readItems(this.current_page)
    },
    searchName: function (newVal) {
      if (!newVal) {
        this.readItems(this.current_page)
      }
    },
    delivery_date: function (newVal) {
      this.readItems(this.current_page)
    },

    loadType: function (newVal) {
      this.readItems(this.current_page)
    },

    '$store.state.currentLocality': function () {
      this.readItems(this.current_page)
    },

    status: function (newVal) {
      this.uncheckAllRows()
      this.selectable = false
      this.readItems(this.current_page)
    },

  },
  methods: {
    onPageChange (page) {
      this.readItems(page)
    },
    clear (field) {
      this.delivery_date = ''
    },
    forceRerender () {
      this.renderComponent = false

      this.$nextTick(() => {
        this.renderComponent = true
      })
    },
    async readItems (page = 0, searchName) {
      this.loading = true

      if (this.selectable === true) {
        this.status.id = 12
      } else {
        this.status.id = ''
      }

      await LoadTypeAPI.getAllLoadTypes().then(response => {
        this.loadTypes = response.data.load_types
      }).catch(e => {
        showError(e)
      })

      // await StatusAPI.getAllStatuses().then(response => {
      //   this.statuses = response.data.statuses
      // }).catch(e => {
      //   showError(e)
      // })

      const params = {
        page: page,
        quantity: this.perPage,
        search: this.searchName,
        delivery_date: this.delivery_date,
        locality: this.currentLocality.id,
        load_type_id: this.loadType.id,
        status_id: this.status.id,
      }
      this.current_page = this.$route.params.current_page

      await LoadAPI.getFilteredLoads(params)
        .then(response => {
          this.data = response.data.loads
          this.totalPages = response.data.total_pages
          this.current_page = response.data.current_page
          // this.delivery_date = (this.$route.params.delivery_date !== undefined) ? `${this.$route.params.delivery_date}` : response.data.last_delivery_date
          this.loading = false
          this.data.checked = false
        }).catch(e => {
          this.loading = false
          showError(e)
        })
    },

    async readDeliveryDate (localityId) {
      await LoadAPI.getLastDeliveryDate(localityId).then(response => {
        this.delivery_date = response.data.last_delivery_date
      }).catch(e => {
        showError(e)
      })
    },

    async getDefaultLoadType () {
      await LoadTypeAPI.getDefaultLoadType().then(response => {
        this.loadType = response.data.load_type
      }).catch(e => {
        showError(e)
      })
    },

    async PalletizedProducts (loadID) {
      await LoadPalletizingAPI.exportPalletizedProducts(loadID, this.currentLocality.id).then(response => {
        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })
      }).catch(e => {
        this.showToast(e.response.data.error, {
          icon: 'fa-thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      })
    },

    async PalletizedAllProducts (delivery_date) {
      await LoadPalletizingAPI.exportAllPalletizedProducts(delivery_date, this.currentLocality.id).then(response => {
        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })
      }).catch(e => {
        this.showToast(e.response.data.error, {
          icon: 'fa-thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      });
    },
    palletizeLoad (loadID) {
      this.loading = true
      LoadPalletizingAPI.palletizeLoad(loadID).then(response => {
        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })

        this.loading = false
        this.forceRerender()
        this.readItems()
      }).catch(e => {
        this.loading = false
        this.showToast(e.response.data.error, {
          icon: 'fa-thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      })
    },

    resetPalletization (loadID) {
      this.loading = true
      LoadPalletizingAPI.resetPalletization(loadID).then(response => {
        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })
        this.loading = false
        this.forceRerender()
        this.readItems()
      }).catch(e => {
        this.loading = false
        this.showToast(e.response.data.error, {
          icon: 'fa-thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      })
    },
    moment: function () {
      return moment()
    },

    updateShowModal (boolean) {
      this.showModal = boolean
    },

    getMessage () {
      return 'Informações da Carga...'
    },

    checkRow (id, checked) {
      const idx = this.data.findIndex(l => l.id === id)
      this.data[idx].checked = checked
      if (checked) {
        this.selectedRows.push(id)
      } else {
        const idx = this.selectedRows.findIndex(l => l === id)
        this.selectedRows.splice(idx, 1)
      }
    },

    uncheckAllRows () {
      this.data.forEach(l => l.checked === false)
      this.selectedRows = []
    },

    palletizeSelectedLoads () {
      this.loading = true
      const selectedLoads = this.data.filter(l => l.checked === true)
      const loadIds = selectedLoads.map(l => l.id)
      LoadPalletizingAPI.palletizeSelectedLoads(loadIds).then(response => {
        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.showToast(e.response.data.error, {
          icon: 'fa-thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      })
      this.selectable = false
      this.uncheckAllRows()
      this.forceRerender()
      this.readItems()
    },

    async PalletizeAllLoads (deliveryDate) {
      this.forceRerender()
      this.readItems()
      this.loading = true
      if (deliveryDate.length === 0) {
        this.showToast('Selecione uma data de entrega', {
          icon: 'fa-thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
        this.loading = false
      } else {
        let params = {
          delivery_date: deliveryDate,
          locality_id: this.currentLocality.id,
        }
        LoadPalletizingAPI.palletizeAllLoads(params).then(response => {
          this.showToast(response.data.message, {
            icon: 'fa-thumbs-o-up',
            position: 'top-right',
            duration: 5000,
          })
          this.loading = false
        }).catch(e => {
          this.loading = false
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
        })
        this.forceRerender()
        this.readItems()
      }
    },
  },
}
</script>
